module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "pt-0",
    staticStyle: {
      "margin-top": "-12px"
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center mt-4",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [(_vm.$hasGranularPermission('observacoes', 'view')) ? _c('v-flex', {
    staticClass: "btn-coluna",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "block": "",
      "to": ({
        name: 'ImoveisDetalhesObservacoes',
        params: {
          tipo: _vm.$route.meta.tipo,
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Observações")])], 1) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('anexos', 'view')) ? _c('v-flex', {
    staticClass: "btn-coluna",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md3": ""
    }
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "block": "",
      "to": ({
        name: 'ImoveisDetalhesAnexos',
        params: {
          tipo: _vm.$route.meta.tipo,
          id: _vm.$route.params.id
        }
      })
    }
  }, [_vm._v("Anexos")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0356ce58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Detalhes/ButtonsObservacoesAnexos.vue
// module id = 981
// module chunks = 1